export const formCategoryStyle = row => ({
  paddingTop: '10px',
  paddingBottom: '10px',
  paddingRight:"20px",
  backgroundColor: row % 2 === 0 ? 'rgb(245, 246, 247)' : 'white',
  display: 'flex',
  alignItems: 'center'
});

export const formCategoryImageStyle = {
  display: 'inline-block',
  verticalAlign: 'top'
};

export const formCategoryContainerStyle = {
  margin: '20px',
   display:"flex"
};
export const selected = {
  border: '1px solid rgb(75, 40, 109)',
  justifyContent: 'space-between',
  padding: '1.75rem',
    flexDirection: 'column',
    webkitBoxPack: 'justify',
    gap: '2rem',
    borderRadius: '1rem',
};
export const unselected = {
  display:'inline-block',
    padding: '1.75rem',
    flexDirection: 'column',
    webkitBoxPack: 'justify',
    justifyContent: 'space-between',
    gap: '2rem',
    border: '1px solid rgb(228, 228, 228)',
    borderRadius: '1rem',
};
export const colorselected = {
  color:"rgb(75, 40, 109)",
  fontWeight:"bold",
  width:"205px"

};
export const unselectedcolor = {
  color: 'rgb(102, 102, 102)',
  width:"205px",
  fontWeight:"bold"
};